import { gsap } from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import сustomPageScroll from '../components/custom-scroll';
import {isLandingPage, isPost} from '../helpers/consts';


gsap.registerPlugin(ScrollTrigger);

export default () => {

	if (isLandingPage || isPost) {
		console.log("Using normal ScrollTrigger on Landing/ Post Page.");
		ScrollTrigger.defaults({ scroller: window });
		ScrollTrigger.refresh();
		return;
	}

	if(сustomPageScroll.scroller === null) return;
	ScrollTrigger.scrollerProxy(сustomPageScroll.wrapper, {
		scrollTop(value) {
			if (arguments.length) {
				сustomPageScroll.scrollTop = value;
			}
			return сustomPageScroll.scroller.scrollTop;
		},
		scrollLeft(value) {
			if (arguments.length) {
				сustomPageScroll.scroller.scrollLeft = value;
			}
			return сustomPageScroll.scroller.scrollLeft;
		}
	});
	сustomPageScroll.scroller.addListener(ScrollTrigger.update);
	ScrollTrigger.defaults({ scroller: сustomPageScroll.wrapper });
};



// gsap.set(".gsap-marker-start, .gsap-marker-end, .gsap-marker-scroller-start, .gsap-marker-scroller-end", {autoAlpha: 0});
// ["red","gray","purple","green"].forEach((triggerClass, i) => {
//   ScrollTrigger.create({
//     trigger: "." + triggerClass,
//     containerAnimation: scrollTween,
//     start: "left 30%",
//     end: i === 3 ? "right right" : "right 30%",
//     markers: false,
//     onToggle: self => gsap.to(".marker-" + (i+1), {duration: 0.25, autoAlpha: self.isActive ? 1 : 0})
//   });
// });


	// // Only necessary to correct marker position - not needed in production
	// if (document.querySelector('.gsap-marker-scroller-start')) {
	// 	const markers = gsap.utils.toArray('[class *= "gsap-marker"]');

	// 	сustomPageScroll.scroller.addListener(({ offset }) => {
	// 		gsap.set(markers, { marginTop: -offset.y })
	// 	});
	// }
